import { TenantConfig } from './tenant-config.type';

/**
 * root
 */
export default (): TenantConfig => ({
  layerDefinitions: [],
  hasMultipleMarkerModes: false,
  defaultCenter: {
    lat: 61.647,
    lng: 27.241,
  },
  defaultZoom: 9.41,
});
